import {IconLabelBadge} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export const PayoutDirectionBadge: FC = () => {
  const {t} = useTranslation('trustAccounts');
  return (
    <IconLabelBadge
      icon="arrow-circle-broken-up-right"
      label={t('view.transactions.payoutBadge')}
    />
  );
};
